<template>
<div>
<!--v-menu
    v-model="simopen"
    width="300px"
    height="300px"
    :close-on-content-click="fal"
    :close-on-click="fal"
-->    
	<v-dialog
		v-model="simopen"
		width="500px"
		height="300px"
	>
	<v-toolbar
        dense
        height="35px"
        color="#E13533"
        dark
    >
        <v-toolbar-title 
            bold>
            <span style="font-weight:600;font-size:1.5rem!important;">効果の高い配信日時</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-on="on"
                v-bind="attrs"
                small
                @click="simopen=false"
            >
                mdi-close
            </v-icon>
            </template>
            <span>閉じる</span>
        </v-tooltip>
    </v-toolbar>
    <v-card
        width ="500px"
        class="pb-5 pt-2"
        style="align-items:center"
        tile
        flat
    >
        <v-card-text>
            <div class="message">リリース配信分析にて<v-icon color="red" small>mdi-heart</v-icon>した企業の配信効果を分析しています。<v-icon color="red" small>mdi-heart</v-icon>を追加するとより正確な日時を知ることができます。</div>
            <v-row class="pt-3">
            <v-col>
            <v-select
                v-model="category"
                :items="category_list"
                item-text="label"
                item-value="cd"
                label="カテゴリ"
            ></v-select>
            </v-col>
            <v-col>
            <v-select
                v-model="kind"
                :items="kind_list"
                item-text="label"
                item-value="cd"
                label="種類"
            ></v-select>
            </v-col>
            </v-row>
        </v-card-text>
        <v-container>
        <v-row
            dense
            style="text-align: center;font-size:1rem"
            no-gutters
        >
            <v-col :class="grid">
                時刻
            </v-col>
            <v-col :class="grid" v-for="week of 7" v-bind:key="week">
                <v-card outlined tile flat dark color="#E13533">
                    <span style="font-size:1.2rem;font-weight:700;">{{ days[week-1] }}</span>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            dense
            style="text-align: center;"
             v-for="hour of 24"
            no-gutters
            v-bind:key="hour"
        >
            <v-col :class="grid">
                <v-card flat>
                    <span v-if="(hour-1)%6 == 0 || (hour-1) == 23">{{ hour-1 }}:00</span>
                </v-card>
            </v-col>
            <v-col v-for="week of 7" :class="grid" v-bind:key="week">
                <v-card outlined tile flat>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                          style="display:block;width:100%;height:15px"
                          :style='"background-color:"+simlist[week-1][hour-1]'
                          @click="showTime"
                          :id="(week-1)+'-'+(hour-1)"
                        ></span>
                      </template>
                      <span>{{ days[week-1] }}曜日{{ hour-1 }}時</span>
                    </v-tooltip>
                </v-card>
            </v-col>
        </v-row>
        </v-container>
    </v-card>
<!--/v-menu-->
</v-dialog>
<v-menu
    v-model="listopen"
    width="400px"
    height="300px"
    :position-x="x"
    :position-y="y"
    absolute
    :close-on-content-click="fal"
>
    <v-list>
        <v-list-item
            v-for="item in date_list"
            v-bind:key="item.date"
        >
            <v-list-item-title>
                <a href="javascript:void(0)" v-on:click="showDial(item.time)">{{ item.date }}</a>
            </v-list-item-title>
        </v-list-item>
    </v-list>
</v-menu>
<v-dialog
    v-model="relconf"
    width="600px"
>
    <v-toolbar
        dark
        tile
        flat
        height="30px"
        color="#E13533"
    >
        <v-spacer></v-spacer>
        <v-icon
            @click="close_event"
        >
            mdi-close
        </v-icon>
    </v-toolbar>
    <v-card
        width="600px"
        flat
        tile
    >
        <v-card-title outlined>
            <h2>続けてプレスリリースを作成しますか？</h2>
        </v-card-title>
        <v-card-text>
            <v-icon
                small
            >
                mdi-lead-pencil
            </v-icon>
            <span>編集ツールを起動してプレスリリースを作成することができます。</span>
        </v-card-text>
        <div style="text-align:center">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="teal accent-4"
            @click="release_edit"
          >
            はい
          </v-btn>
          <v-btn
            text
            color="teal accent-4"
            @click="close_event"
          >
            いいえ    
          </v-btn>
        </v-card-actions>
        </div>
    </v-card>
</v-dialog>
</div>
</template>
<script>
export default {
    props : ["relconfirm","sch_id"],
    watch : {
        kind :function(){
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.updateSim()
            }, 500);
        },
        category : function(){
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.updateSim()
            }, 500);
        },
        relconfirm : function(){
            this.relconf = this.relconfirm;
        },
    },
    data: () => ({
        timeout   : null,
        relconf  : false,
        simopen  : false,
        listopen : false,
        fal     : false,
        simlist : [],
        days    : ["日","月","火","水","木","金","土"],
        grid    : "pa-0",
        date_list : [],
        view_time : null,
        x         : 900,
        y         : 300,
        kind      : "",
        category  : "",
        category_list : [],
        kind_list : [],
    }),
    methods:{
        release_edit(){
            //this.$emit('relclose',{edit:true});
           this.$router.push({name: 'Edit', params: {sch_id: this.sch_id}});

        },
        close_event(){
            this.$emit('relclose',{edit:false});
        },
        showDial(data)
        {
			this.listopen = false;
            this.$emit('select-release',{"date":data});
        },
        showTime(event){
            var moment = require("moment");
            this.date_list = [];
            const id = event.target.id.split('-');
            const nowday = moment().format('e');
            let start_date  = null; 
            this.view_time = id[1];
            if(id[0]<nowday)
                start_date = moment().add(id[0]-nowday+7,'d').format('YYYY-MM-DD');
            else
                start_date = moment().add(id[0]-nowday,'d').format('YYYY-MM-DD');

            start_date += " "+this.view_time + ":00";

            for(let i=0;i<5;i++)
            {
                this.date_list.push({
                    "date":moment(start_date).add(7*i,'d').format('YYYY年MM月DD日HH:mm'),
                    "time":moment(start_date).add(7*i,'d').format('YYYY-MM-DD HH:mm')
                });
            }
            const open = () => {
              requestAnimationFrame(() => requestAnimationFrame(() => this.listopen=true))
            }

            this.$nextTick(() => {
                if (this.listopen) {
                    this.listopen = false
                    requestAnimationFrame(() => requestAnimationFrame(() => open()))
                } else {
                    open()
                }
                event.stopPropagation()
            });

        },
        async updateSim(){
			const axios = require('axios');
            var params = new URLSearchParams();
            if (this.category != "" && this.category != null && this.category != 0)
            {
                params.append("category",this.category);
            }
            if (this.kind != "" && this.kind != null && this.kind != 0)
            {
                params.append("kind",this.kind);
            }
            await axios.post("https://qlipper.jp/api/events/get_sim.php",params,{withCredentials: true,})
            .then(response => {
                this.simlist = response.data;
            });
        },
        async simOpen (){
			const axios = require('axios');
            await axios.post("https://qlipper.jp/api/events/get_sim.php",null,{withCredentials: true,})
            .then(response => {
                this.simlist = response.data;
                this.simopen = true;
                this.$emit('opened');
            });
        },
        simClose (){
            this.simopen=false;
            this.listopen=false;
        },
    },
    created : async function(){
        const axios = require('axios');
        var params = new URLSearchParams();
        await axios.post("https://qlipper.jp/api/release/get_search_box",params)
        .then(response => {
            this.category_list = response.data['category'];
            this.kind_list = response.data['kind'];
        });

    },
};
</script>
<style>
.message{
	font-size : 1.2rem!important;
}
</style>
